import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { DistributorHeader as Header } from 'enlm_ui_common';
import { isEmpty, get } from '../../../utils/lodash';
import { forwardTo } from '../../../utils/helper';

const DistributorHeader = props => {
  const search = get(props, 'location.search', '');
  const { token } = queryString.parse(search);
  if (!isEmpty(token)) {
    return null;
  }
  return <Header {...props} forwardTo={forwardTo}/>;
};

const mapStateToProps = state => ({
  countryCode: state.appReducer.countryCode,
  enlightenManagerToken: state.appReducer.enlightenManagerToken,
  accountDetail: state.accountReducer.accountDetail,
  locale: state.accountReducer.locale
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DistributorHeader);
